import WidgetComponent from 'components/WidgetComponent'
import { h, Component } from 'preact';
import style from './style.less'; 
import {connect} from 'react-redux'
import {Form, I18n, Row, Col, Container, Button} from 'components/elements'
import {FASpinner} from 'components/elements/FontAwesome'
import {
    AccountActions, 
    FilterActions, 
    LocaleActions, 
    SessionActions,
    PageActions
} from 'actions'


@Form
@connect((state)=> state)
export default class LoginOrSignup extends WidgetComponent { 
	constructor(){
        super()
        this.state={
            validPhone: false,
            validEmail: false
        }
        this.handleEmailChange = this.handleEmailChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.setFilter = this.setFilter.bind(this)
        this.filterSubmitSpinner = this.filterSubmitSpinner.bind(this)
        this.handlePhoneNumberValidation = this.handlePhoneNumberValidation.bind(this)
	}

    handleEmailChange(e){
        e.preventDefault()
        
        const validEmail = e.target.value.includes('@');
        if(this.state.validEmail !== validEmail){
            this.setState({
                _emailAuthenticator: e.target.value,
                validEmail
            })
        }
    }

    handlePhoneNumberValidation(e){
        e.preventDefault()
        let phoneNumberRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
        
        const validPhone = e.target.value.match(phoneNumberRegex)
        if(this.state.validPhone !== validPhone) {
            this.setState({
                _phoneNumberAuthenticator: e.target.value.replaceAll('-',''),
                validPhone
            })
        }
    }

    handleSubmit(formData){
        let email = formData.email
        let mobilePhone = formData.mobilePhone
        if(mobilePhone) {
            mobilePhone = mobilePhone.replaceAll('-','')    
        }
        AccountActions.authenticatorCheck({
            email, 
            mobilePhone
        }).then((response)=>{
            if(response.data.email || response.data.mobilePhone){
                SessionActions.setAuthenticationMode('login')
                PageActions.navToLogin()
            } else {
                SessionActions.setAuthenticationMode('signup')
                PageActions.navToFilters()
            }

            this.setFilter({authenticator: email || mobilePhone})
            AccountActions.set({
                email,
                mobilePhone
            })

            super.componentDidSubmit()
        })
        .catch((e)=>{
            console.log(e)
        })
    }

    setFilter(data){
        FilterActions.set({
            ...this.props.filters,
            ...data
        })
    }   

    filterSubmitSpinner(){
        return this.props.loading.organization || this.props.loading.patientData
    }

    get session(){
        return this.props.session || {}
    }

    get validAuthenticator(){
        return this.state.validEmail && this.state.validPhone
    }

	render() {
        const {Form, InputDark, MaskedInputDark} = this.props
        
        return (
            <Form id='loginOrSignup' onSubmit={this.handleSubmit} class={this.session.resetPassword && style.faded}>
                {this.props.loading.init ? (
                    <div style={{height: '240px', paddingTop: '70px'}}>
                        <FASpinner class={style.spinner} />
                    </div>
                ) : (
                    <Row class={this.props.class}>
                        <Col span={{sm:'hidden', md:5}}></Col>
                        <Col span={{sm:24, md:14}}>
                            <Container>
                                <Row>
                                    <Col span={{md:1, sm: 'hidden'}}></Col>
                                    <Col span={{sm:24, md:22}} class={style.noPadding}>          
                                        <h3>{I18n.t('enterYourEmail')}</h3>
                                        <InputDark 
                                            autoComplete='email'
                                            class={style.height}
                                            required={!this.validAuthenticator}
                                            name="email"
                                            id="email" 
                                            key="email"
                                            pattern=".+@.+\..+"
                                            placeholder={I18n.t('johnDoeEmail')}
                                            onChange={this.handleEmailChange} 
                                            initialValue={this.props.config.prefillEmail}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={{md:1}}></Col>
                                    <Col span={{sm:24, md:22}} class={style.noPadding}>            
                                        <h3>{I18n.t('enterYourPhoneNumber')}</h3>
                                        <MaskedInputDark 
                                            autoComplete='tel'
                                            class={style.height}
                                            required={!this.validAuthenticator}
                                            name="mobilePhone" 
                                            type="tel"
                                            id="mobile-phone" 
                                            key="mobile-phone"
                                            pattern="[0-9]{3}[\-][0-9]{3}[\-][0-9]{4}" 
                                            placeholder='555-555-5555'
                                            onChange={this.handlePhoneNumberValidation} 
                                            initialValue={this.props.config.prefillMobilePhone}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={{sm:6, md:8}}></Col>
                                    <Col span={{sm:12, md:8}}>
                                        <div class={style.searchButton}>
                                            <Button
                                                type='submit'
                                                // spinner={this.props.loading}
                                            >
                                                {I18n.t('submit')}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                    </Row>
                )}
            </Form>
		);
	}
}



// WEBPACK FOOTER //
// ./components/groups/LoginOrSignup/index.js